import React, { useState } from "react";
import Page from "../components/Page";
import Grid from "@mui/material/Grid";
import { primaryBlue } from "../constants";
import { connect } from "react-redux";
import Head from "../components/Head";
import { Placeholder } from "../components/MyPredictions";
import { Table, TableCell, TableRow } from "@mui/material";
import Button from "../elements/Button";
import CalculateIcon from "@mui/icons-material/Calculate";
import API from "../api";
import { useNavigate } from "react-router-dom";
import { fetchApplicationData } from "../actions/init";
import TeamLogo from "../components/TeamLogo";

const styles = {
  section: {
    padding: 8,
    backgroundColor: primaryBlue,
  },
  input: {
    width: 30,
    height: 40,
    fontSize: "2rem",
    textAlign: "center",
    padding: 4,
    color: primaryBlue,
  },
  inputWrapper: {
    fontSize: "2rem",
    display: "flex",
    alignItems: "center",
    marginLeft: 8,
  },
  closeRoundBtn: {
    display: "flex",
    alignItems: "space-between",
    height: 80,
    justifyContent: "center",
  },
};

const Administration = ({
  matches,
  loaded,
  isAdmin,
  isCurrentGameClosed,
  fetchApplicationData,
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const canCloseRound =
    !isCurrentGameClosed &&
    matches.filter((match) => !match.Calculated).length === 0;
  const canStartRound = Boolean(isCurrentGameClosed);

  const calculate = async () => {
    try {
      setLoading(true);
      await API.calculate();
      fetchApplicationData();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const saveMatch = async (matchId) => {
    const firstScore = document.getElementById("firstScore-" + matchId)?.value;
    const secondScore = document.getElementById("secondScore-" + matchId)
      ?.value;

    if (firstScore && secondScore) {
      try {
        setLoading(true);
        await API.saveMatch({
          MatchId: matchId,
          FirstScore: Number(firstScore),
          SecondScore: Number(secondScore),
        });
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const closeRound = async () => {
    try {
      setLoading(true);
      await API.closeRound();
      fetchApplicationData();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const newRound = async () => {
    try {
      setLoading(true);
      await API.newRound();
      fetchApplicationData();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  if (!isAdmin) {
    navigate("/");
  }

  return (
    <Page>
      <Grid item xs={12}>
        <Head
          text="Адміністрування"
          action={
            !loading ? (
              <CalculateIcon
                style={{ fontSize: 32, cursor: "pointer", marginRight: 12 }}
                onClick={calculate}
                className="hovered"
              />
            ) : null
          }
        />
        <div className="p-2">
          {loaded ? (
            <Table>
              {matches
                .filter((m) => !m.Calculated)
                .map((match, index) => (
                  <TableRow>
                    <TableCell align="left" className="min-2-50 !p-0">
                      <Grid
                        className="relative flex w-full"
                        container
                        alignItems={"center"}
                        justifyContent={"flex-start"}
                      >
                        <div className="flex w-full justify-between items-center">
                          <div className="flex items-center w-1/3">
                            <TeamLogo teamId={match?.FirstTeam} isFirstTeam />
                            <span className="text-xl ml-1 md:ml-3">
                              {match?.FirstTeam}
                            </span>
                          </div>
                          <div className="flex justify-center items-center ml-2 text-2xl w-1/3">
                            <input
                              defaultValue={match.FirstScore}
                              id={`firstScore-${match.MatchId}`}
                              className="w-8 h-8 text-2xl text-center p-1 text-primary"
                              type="text"
                            />
                            &nbsp;:&nbsp;
                            <input
                              defaultValue={match.SecondScore}
                              className="w-8 h-8 text-2xl text-center p-1 text-primary"
                              id={`secondScore-${match.MatchId}`}
                              type="text"
                            />
                          </div>
                          &nbsp;
                          <div className="flex justify-end items-center w-1/3">
                            <span className="text-xl mr-1 md:mr-3">
                              {match?.SecondTeam}
                            </span>
                            <TeamLogo teamId={match?.SecondTeam} />
                          </div>
                        </div>
                      </Grid>
                    </TableCell>
                    <TableCell className="!flex !justify-end border-b-0">
                      <Button
                        disabled={loading}
                        onClick={() => saveMatch(match.MatchId)}
                        minWidth={0}
                      >
                        SAVE
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </Table>
          ) : (
            <Placeholder meActive={true} loaded={loaded} />
          )}
        </div>
      </Grid>
      <div style={styles.closeRoundBtn}>
        {canCloseRound && <Button onClick={closeRound}>Закрити тур</Button>}
        {canStartRound && <Button onClick={newRound}>Новий тур</Button>}
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  matches: state.matches,
  loaded: state.app.loaded,
  isAdmin: state?.user?.me?.isAdmin,
  isCurrentGameClosed: state?.user?.isCurrentGameClosed,
});

const mapDispatchToProps = (dispatch) => ({
  fetchApplicationData: (navigate) => dispatch(fetchApplicationData(navigate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Administration);
